import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "@/pages/Login";
import StaffDashboard from "@/pages/StaffDashboard";
import DoctorDashboard from "@/pages/DoctorDashboard";
import NursingDashboard from "@/pages/NursingDashboard";
import TVDisplay from "@/pages/TVDisplay";
import Reports from "@/pages/Reports";
import PublicWebsite from "@/pages/PublicWebsite";
import LabDashboard from "@/pages/LabDashboard";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicWebsite />} />
          <Route path="/website" element={<Navigate to="/" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/display" element={<TVDisplay />} />
          <Route
            path="/staff"
            element={
              <ProtectedRoute allowedRole="staff">
                <StaffDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/doctor"
            element={
              <ProtectedRoute allowedRole="doctor">
                <DoctorDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/nursing"
            element={
              <ProtectedRoute allowedRole="nurse">
                <NursingDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute allowedRole="doctor">
                <Reports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lab"
            element={
              <ProtectedRoute allowedRole="lab">
                <LabDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  );
}

export default App;